/* eslint-disable react/require-default-props */
import React from 'react';

interface AiManagementCheckboxProps {
  id: string;
  checked: boolean;
  className?: string;
  onChange: () => void;
  children: React.ReactNode;
}

const AiManagementCheckbox: React.FC<AiManagementCheckboxProps> = ({
  id,
  checked,
  className = '',
  onChange,
  children,
}) => (
  <div className={`custom-control custom-checkbox ${className}`}>
    <input
      id={id}
      type="checkbox"
      className="custom-control-input"
      checked={checked}
      onChange={onChange}
    />
    <label className="custom-control-label" htmlFor={id}>
      {children}
    </label>
  </div>
);

export default AiManagementCheckbox;
